import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { MapN2pComponent } from "../map-n2p/map-n2p.component";
import { TableComponent } from "../../components/common/table/table.component";
import { TitleTextPipe } from "../../custom.pipe";
import { FormGroup, FormBuilder, Validators,ReactiveFormsModule } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { ApiService } from "../../api.service";
import { LfnPathGenerartionComponent } from "../../components/lfn-flow/lfn-path-generartion/lfn-path-generartion.component";
import { MessageComponent } from "../../components/common/message/message.component";
import {UploadFileComponent} from "../../components/common/upload-file/upload-file.component"
import { FormsModule } from '@angular/forms';

@Component({
  selector: "app-smp-connectivity-n2p",
  standalone: true,
  imports: [
    TableComponent,ReactiveFormsModule,
    CommonModule,
    FormsModule,
    MapN2pComponent,MessageComponent,
    NgxSpinnerModule, TitleTextPipe,UploadFileComponent
  ],
  templateUrl: "./smp-connectivity-n2p.component.html",
  styleUrls: ["./smp-connectivity-n2p.component.scss"]
})

export class SmpConnectivityN2pComponent implements OnInit {
  smp_connectivity_table: boolean = false;
  
  isLoading: boolean = false;
  myEquipmetForm: any = FormGroup;
  @Input() tableData: any;
  showTable: boolean = false;

  table2Data: any;
  showType2Table: boolean = false;
  showMap: boolean = false;
  mapData: any;
  showMessage: boolean = false;
  show_smp_table: boolean = false;
  MessageToShow: any;
  url: string = '';
  filename: string = '';
  msg: string = ''; 
  selectedFJLSPL: string ='';

  @Input() inputData: any;
  
  @ViewChild(TableComponent)
  tableChildComponent!: TableComponent;

  @ViewChild(MapN2pComponent)
  mapChildComponent!: MapN2pComponent;

  @ViewChild(LfnPathGenerartionComponent)
  lfnPathGeneration!: LfnPathGenerartionComponent;

  showEquipmetTable: boolean = false;
  map_div: boolean = true;
  success_path: boolean = false;
  upstream_screen: boolean = false;
  showBJLTable: boolean = true;
  select_bjl: boolean = false;
  title: string = '';
  select_smp_screen: boolean = false;
  final_screen: boolean = false;
  showADRCard: boolean = false;
  selectedRow: any;
  flowName:string='N2P ADR';
  myAdrForm!: FormGroup;
  alternate_path: boolean = false;
  file: string | null = null;
  select_bjl_structure_payload: any;
  pit_value : string = "";
  show_status:boolean = false;
  pit_validation:any;
  show_distance = false;
  update_pit:boolean = false;
  pit_size_value : string = "";
  trench_creation:boolean = false;
  no_of_pits:string = '';
  a_pit:string = '';
  z_pit:string = '';
  user_message:string='';
  selectedSPL :string = '';
  fjl_id: string ='';

  constructor(private toastr: ToastrService,
    private fb: FormBuilder,
    private apiService: ApiService,
    private spinner: NgxSpinnerService
  )
  { 
      this.myEquipmetForm = this.fb.group({
            equpType: ['', Validators.required],
      });
      this.myAdrForm = this.fb.group({
        ADRpath: [''],
      });
  }
  
  ngOnInit() {
    
  if (this.inputData.message.includes(' mpt ')) {
      this.title = 'MPT';
    }
    else if (this.inputData.message.includes(' bjl ')) {
      this.title = 'BJL';      
    }
    else if (this.inputData.message.includes(' ajl ')) {
      this.title = 'AJL';      
    }
    else if (this.inputData.message.includes(' smp')) {
      this.title = 'SMP';      
    }
  }
  


  fileUploaded(event: string) {
    this.file = event;
  }

  receiveTableEvent(data:any) {    
    this.viewProfile(data);
    
  }

  viewProfile(data: any) {  
    // on select button clicked on table it'll call map component for pin point the structure id
    this.isLoading = true;
     
    if(
            ['select bjl structure n2p', 'select existing smp','select new smp'].includes(
              this.inputData.message
            )
    ) {
        if ('smp_lat' in data) {
          this.mapChildComponent.receiveTableEvent(data)
        }
    }
      else if (
      ['select mpt upstream equipment','select ajl upstream equipment'].includes(
        this.inputData.message
      )
    ) {
      this.inputData['selected_upstream_equipment'] = data;
      if (this.inputData.message == 'select ajl upstream equipment') {
        this.inputData['selected_ajl_upstream_equipment'] = [data];
      }
      
      this.apiService.selectUpstremEquipment(this.inputData).subscribe({
        next: (response) => {
          if(
            ['select bjl structure n2p', 'select mpt structure','select smp structure'].includes(
              response.message
            )
          ) {
            this.inputData = response;
            this.showTable = false;
            this.showEquipmetTable = false;
            this.tableData = response;
            this.tableChildComponent.initializeFunction(this.inputData);
            
            this.showMap = true;
            this.mapData = data;
            this.map_div = true;
            
          } else {
            this.toastr.error(
              response.message,
            'Error Message'
            );
          }
          this.isLoading = false;
        },
        error: (error) => {
          this.isLoading = false;
          
          this.toastr.error(
            `The API returned Unsuccessfull response : ${error}`,
            'Error Message'
          );
        },
      });
 
    }
    else {
      this.inputData['selected_path'] = data;
    }
  }

  OnSelectProceedMap(data: any) {
    // On Button click call jl structure api and based on response trigger next step
    
      this.isLoading = true;
      this.spinner.show();
      this.showTable = false;
      let smp_state_count = 0;
      let smp_state_count_error = 0;
      if ('locations_served_from_smp' in this.inputData) {
          for (let i = 0; i < this.inputData.locations_served_from_smp.length; i++){
                if ('smp_state' in this.inputData.locations_served_from_smp[i]) {
                    if (this.inputData.locations_served_from_smp[i].smp_state == 'yes'){
                      if('new_location' in this.inputData.locations_served_from_smp[i] || 'suggested_location_id' in this.inputData.locations_served_from_smp[i]){
                        console.log('true')
                      }
                      else{
                        alert('Please provide a new location or the suggested_location; otherwise, select No to proceed without action. For '+ this.inputData.locations_served_from_smp[i].smp_id + ' and port ' + this.inputData.locations_served_from_smp[i].smp_port)
                      }
                    }
                    smp_state_count++;
                }
                else {
                  //smp_state_count_error++;
                    this.inputData.locations_served_from_smp[i]['smp_state'] = 'no';
            }
            
            
            }
      }
      if(smp_state_count_error>0){
        this.toastr.error(
                'select all mandatory fields.',
              'Error Message'
            );
        this.isLoading = false;
        this.spinner.hide();
      }
      else {
        const uniqueArray = this.inputData.selected_smp.filter((o: any, index: any, arr: any[]) =>
                arr.findIndex((item: any) => JSON.stringify(item) === JSON.stringify(o)) === index
            );
        console.log(uniqueArray);
        this.inputData.selected_smp = uniqueArray
    this.apiService.selectSmpLocationN2P(this.inputData).subscribe({
      next: (response) => {
      
        if (response.message === "select bjl n2p") {
            this.map_div = false;
            this.inputData = response;
            this.select_bjl = true;   
            this.tableData = response;
            this.show_distance = false;
        }
        else if (response.message == "select existing smp") {
          this.inputData = response;
          this.tableData = response;
            this.tableChildComponent.initializeFunction(this.inputData);            
            this.showMap = true;
            this.mapData = data;
            this.map_div = true;
            this.mapChildComponent.receiveTableEvent(this.inputData,'yes');
        }
        else if (response.message === 'select upstream equipment n2p') {
              this.map_div = false;
              this.select_bjl = false;
              this.upstream_screen = true;
              this.inputData = response;
              this.tableData = response;
              this.tableChildComponent.initializeFunction(this.inputData);
          if ('error_messgae' in response) {
                this.toastr.error(
                    response.error_messgae,
                  'Error Message'
                );
              }
        }
        else if (response.message == 'n2p process completed') {
              this.map_div = false;
              this.select_smp_screen = false;
              this.upstream_screen = false;
              this.select_bjl = false;
              this.final_screen = true;
              this.tableData = response;
              this.inputData = response;
        }
        else {
            this.toastr.error(
                response.message,
              'Error Message'
            );
          }

        this.isLoading = false;
        this.spinner.hide();
      },
        error: (error) => {
          this.isLoading = false;
          this.spinner.hide();
          window.alert(`The API returned Unsuccessfull response : ${error}`);
        },
      });
    
    }
    }

  receiveTableEventBJL(data:any) {
    this.inputData['selected_bjl'] = data;
    this.isLoading = true;
    this.spinner.show()  
    if(this.inputData.request_type == "FMB_request"){
        this.apiService.checkBjlCapacityN2P(this.inputData).subscribe({
        next: (response) => {
              if (response.message == 'select bjl n2p') {
                this.select_bjl = true;
                this.upstream_screen = false;
                this.inputData = response;
                this.tableData = response;
                if(this.inputData.user_message != ''){
                  this.user_message = this.inputData.user_message;
                }
                this.tableChildComponent.initializeFunction(this.inputData);
              }
              else if(response.message == 'n2p process completed'){
                  this.select_bjl = false;
                  this.final_screen = true;
                  this.tableData = response;
                  this.inputData = response;
              }
                else if (response.message == 'select upstream equipment n2p') {
                this.select_bjl = false;
                this.upstream_screen = true;
                this.inputData = response;
                this.tableData = response;
                this.tableChildComponent.initializeFunction(this.inputData);
              }
              else {              
                if ('file_name' in response) {
                  this.select_bjl = false;
                  this.showMessage = true;
                  this.MessageToShow = response;
                } else {
                  this.toastr.error(response.message, 'Error Message');
                  console.log('error');
                }
              }

              this.isLoading = false;
              this.spinner.hide();
              // window.alert(response.messgae);
        }
        ,
        error: (error) => {
              this.isLoading = false;
              this.spinner.hide();
              this.toastr.error(
                `The API returned Unsuccessfull response : ${error}`,
                'Error Message'
              );
            },
      });
    }
    else{
    this.apiService.selectBjlN2P(this.inputData).subscribe({
      next: (response) => {

            if (response.message === 'select smp structure') {
              this.select_bjl = false;
              this.upstream_screen = false;
              this.inputData = response;
              this.select_smp_screen = true;
              this.show_smp_table = true;
              this.tableData = response;
              this.show_status = false;
            }
            else if (response.message == 'select bjl n2p') {
              this.select_bjl = true;
              this.upstream_screen = false;
              this.inputData = response;
              this.tableData = response;
              this.show_distance = false;
              this.show_status = false;
              this.tableChildComponent.initializeFunction(this.inputData);
            }
            else if (response.message == 'select upstream equipment n2p') {
              this.map_div = false;
              this.select_bjl = false;
              this.upstream_screen = true;
              this.inputData = response;
              this.tableData = response;
              this.show_status = false;
              this.tableChildComponent.initializeFunction(this.inputData);
            }
            else {              
              if ('file_name' in response) {
                this.select_bjl = false;
                this.upstream_screen = false;
                this.showMessage = true;
                this.MessageToShow = response;
              } else {
                this.toastr.error(response.message, 'Error Message');
                console.log('error');
              }
            }

            this.isLoading = false;
            this.spinner.hide();
            // window.alert(response.messgae);
      }
      ,
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
            //window.alert(`The API returned Unsuccessfull response : ${error}`);
          },
    });
  }
  }

  addSPL() {
  this.inputData['spl_details'] = this.selectedSPL;
  this.isLoading = true;
  this.spinner.show();
  this.apiService.newSPL(this.inputData).subscribe({
    next: (response) => {
      if (response.message === 'select bjl n2p') {
        this.showBJLTable = true;
        this.upstream_screen = false;
        this.inputData = response;
        this.tableData = response;
        if (this.inputData.user_message !== '') {
          this.user_message = this.inputData.user_message;
        }
        this.tableChildComponent.initializeFunction(this.inputData);
        
        // window.alert(response.messgae);
      }
       else {
            this.toastr.error(
                response.message,
              'Error Message'
            );
          }
      this.isLoading = false;
      this.spinner.hide();
    },
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
            //window.alert(`The API returned Unsuccessfull response : ${error}`);
      },
  });
}

  fjladdSPL() {
  this.inputData['spl_type'] = this.selectedFJLSPL;
  this.inputData['fjl_id'] = this.fjl_id
  this.isLoading = true;
  this.spinner.show();
  this.apiService.newFJLSPL(this.inputData).subscribe({
    next: (response) => {
      if (response.message == 'select upstream equipment n2p') {
                this.showBJLTable = false;
                this.upstream_screen = true;
                this.inputData = response;
                this.tableData = response;
                this.tableChildComponent.initializeFunction(this.inputData);
              }

      else {
            this.toastr.error(
                response.message,
              'Error Message'
            );
          }
      this.isLoading = false;
      this.spinner.hide();  
    },
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
            //window.alert(`The API returned Unsuccessfull response : ${error}`);
      },
  });
}


onSPLChange(event: Event) {
  const select = event.target as HTMLSelectElement;
  this.selectedSPL = select.value;
  // Also store it in inputData for convenience
  this.inputData['spl_details'] = this.selectedSPL;
}
onfjlSPLChange(event: Event) {
  const select = event.target as HTMLSelectElement;
  this.selectedFJLSPL = select.value;
  // Also store it in inputData for convenience
  this.inputData['spl_type'] = this.selectedFJLSPL;
}

  callBJL() {
      this.apiService.bjlpathoverwriteN2P(this.inputData).subscribe({
          next: (response) => {
          if (response.message == 'select upstream equipment n2p') {
              this.map_div = false;
            this.select_bjl = false;
            this.select_smp_screen = false;
                this.upstream_screen = true;
                this.inputData = response;
                this.tableData = response;
                this.tableChildComponent.initializeFunction(this.inputData);
            } else {
              //this.showTable = false;
              this.toastr.error(
              `The API returned Unsuccessfull response`,
              'Error Message'
            );
            }

            this.isLoading = false;
            this.spinner.hide();
          },
          error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
          },
        });
    }

  OnSelectProceedMapSelectSMP(data: any) {
    this.isLoading = true;
      this.spinner.show()  
      this.pit_value = '';
      if(this.inputData.request_type == "FMB_request"){
        this.apiService.newBjl(this.inputData).subscribe({
        next: (response) => {
              if (response.message == 'select bjl n2p') {
                this.select_bjl = true;
                this.upstream_screen = false;
                this.select_smp_screen = false;
                this.inputData = response;
                this.tableData = response;
                if(this.inputData.user_message != ''){
                  this.user_message = this.inputData.user_message;
                }
                //this.tableChildComponent.initializeFunction(this.inputData);
              }
               
              else if(response.message == 'n2p process completed'){
                  this.select_bjl = false;
                  this.final_screen = true;
                  this.tableData = response;
                  this.inputData = response;
              }
              else {              
                if ('file_name' in response) {
                  this.select_bjl = false;
                  this.showMessage = true;
                  this.MessageToShow = response;
                } else {
                  this.toastr.error(response.message, 'Error Message');
                  console.log('error');
                }
              }

              this.isLoading = false;
              this.spinner.hide();
              // window.alert(response.messgae);
        }
        ,
        error: (error) => {
              this.isLoading = false;
              this.spinner.hide();
              this.toastr.error(
                `The API returned Unsuccessfull response : ${error}`,
                'Error Message'
              );
            },
      });
    }
    else
      {
    this.apiService.selectSmpStructureN2P(this.inputData,this.inputData.message).subscribe({
      next: (response) => {

            if (response.message === 'select smp structure') {
              this.select_bjl = false;
              this.upstream_screen = false;
              this.inputData = response;
              this.tableData = response;
              this.select_smp_screen = true;
              this.show_smp_table = true;
              this.show_status = false;
              //this.tableChildComponent.initializeFunction(this.inputData);
              //this.mapChildComponent.receiveTableEvent(this.inputData);
            }
            else if (response.message == 'select bjl structure n2p') {
              this.map_div = false;
              this.select_bjl = false;
              this.upstream_screen = false;
              this.inputData = response;
              this.tableData = response;
              this.select_smp_screen = true;
              this.show_smp_table = false;
              this.show_distance = false;
              this.select_bjl_structure_payload = response;
              //this.tableChildComponent.initializeFunction(this.inputData);
              this.mapChildComponent.receiveTableEvent(this.inputData);
            }
            else if (response.message == 'select new smp') {
              this.map_div = true;
              this.select_smp_screen = false;
              this.upstream_screen = false;
              this.select_bjl = false;
              this.tableData = response;
              this.inputData = response;
            }
              else if (response.message == 'n2p process completed') {
              this.map_div = false;
              this.select_smp_screen = false;
              this.upstream_screen = false;
              this.select_bjl = false;
              this.final_screen = true;
              this.tableData = response;
              this.inputData = response;
              }
              else if (response.message == 'select new fmb') {
                  this.map_div = false;
                  this.select_smp_screen = false;
                  this.upstream_screen = false;
                  this.select_bjl = false;
                  this.final_screen = true;
                  this.tableData = response;
                  this.inputData = response;
              }
            else {              
              if ('file_name' in response) {
                this.select_bjl = false;
                this.upstream_screen = false;
                this.showMessage = true;
                this.MessageToShow = response;
              } else {
                this.toastr.error(response.message, 'Error Message');
                console.log('error');
              }
            }

            this.isLoading = false;
            this.spinner.hide();
      }
      ,
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
          },
    
        });
      }
  }

  receiveTableEventStructureSelectSMP(data: any) {
    this.mapChildComponent.receiveTableEvent(data,'bjl_smp')
  }

  receiveTableEventUpstream(data: any) {
    this.inputData['selected_upstream_equipment'] = data;
    this.isLoading = true;
    this.spinner.show();
    this.apiService.selectUpstreamStructureN2P(this.inputData).subscribe({
      next: (response) => {

        if (response.message === 'select bjl structure n2p') {
              this.map_div = false;
              this.select_bjl = false;
              this.upstream_screen = false;
              this.inputData = response;
              this.select_smp_screen = true;
              this.update_pit = true;
              this.show_smp_table = false;
              this.show_distance = false;
              this.show_status = false;
          this.tableData = response;
          this.select_bjl_structure_payload = response;
            }            
            else {              
              if ('file_name' in response) {
                this.select_bjl = false;
                this.upstream_screen = false;
                this.showMessage = true;
                this.MessageToShow = response;
              } else {
                this.toastr.error(response.message, 'Error Message');
                console.log('error');
              }
            }

            this.isLoading = false;
            this.spinner.hide();
            // window.alert(response.messgae);
      }
      ,
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
            //window.alert(`The API returned Unsuccessfull response : ${error}`);
          },
    });
  }

  receiveTableEventFinalCall() {
    this.isLoading = true;
      this.spinner.show()  
    
    if(this.inputData.message == 'select new fmb'){
        this.apiService.callFnB(this.inputData).subscribe({
      next: (response) => {
                if (response.message == 'Pre-signed url has been generated') {
                  this.map_div = false;
                  this.select_smp_screen = false;
                  this.upstream_screen = false;
                  this.select_bjl = false;
                  this.final_screen = false;
                  this.showMessage = true; 
                  this.url = response.url;
                  this.filename = response.file_name;
                  this.msg = response.message;
                  this.MessageToShow = JSON.stringify(response);
                }
                else if (response.message == 'upload adr') {
                  this.showADRCard = true;
                  this.map_div = false;
                  this.select_smp_screen = false;
                  this.upstream_screen = false;
                  this.select_bjl = false;
                  this.final_screen = false;
                  this.inputData = response;
                }
                else {              
                  if ('file_name' in response) {
                    this.select_bjl = false;
                    this.upstream_screen = false;
                    this.showMessage = true;
                    this.MessageToShow = response;
                  } else {
                    this.toastr.error(response.message, 'Error Message');
                    console.log('error');
                  }
                }

            this.isLoading = false;
            this.spinner.hide();
      },
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
          },
    });
    }else{
    this.apiService.generateN2pOutput(this.inputData).subscribe({
      next: (response) => {
                if (response.message == 'Pre-signed url has been generated') {
                  this.map_div = false;
                  this.select_smp_screen = false;
                  this.upstream_screen = false;
                  this.select_bjl = false;
                  this.final_screen = false;
                  this.showMessage = true; 
                  this.url = response.url;
                  this.filename = response.file_name;
                  this.msg = response.message;
                  this.MessageToShow = JSON.stringify(response);
                }
                else if (response.message == 'upload adr') {
                  this.showADRCard = true;
                  this.map_div = false;
                  this.select_smp_screen = false;
                  this.upstream_screen = false;
                  this.select_bjl = false;
                  this.final_screen = false;
                  this.inputData = response;
                }
                else {              
                  if ('file_name' in response) {
                    this.select_bjl = false;
                    this.upstream_screen = false;
                    this.showMessage = true;
                    this.MessageToShow = response;
                  } else {
                    this.toastr.error(response.message, 'Error Message');
                    console.log('error');
                  }
                }

            this.isLoading = false;
            this.spinner.hide();
      },
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
          },
    });
  }
  }

  table_function_called() {
    this.isLoading = true;
    this.spinner.show();
    if (this.selectedRow && this.selectedRow.length > 0) {
      let new_route_list = [];
      for (let ele of this.selectedRow) {
        new_route_list.push(ele['Paths']);
      }
      this.inputData['new_route_list'] = new_route_list;
    }
    this.inputData['adr_path'] = this.myAdrForm.value.ADRpath;
    this.inputData['adr_file_name'] = this.file;

    this.inputData['available_paths'] = this.inputData['available_paths'];
    this.apiService.onadrcallN2P(this.inputData).subscribe({
      next: (response) => {
        this.showADRCard = false;

        if (response.message.indexOf(
            "Tool generated path doesn't match with ADR"
          ) != -1
        ) {
          this.url = response.url;
          this.filename = response.file_name;
          this.msg = response.message;
          this.showMessage = true;
          this.MessageToShow = JSON.stringify(response);
        } else if (response.message == 'Pre-signed url has been generated') {
          this.url = response.url;
          this.filename = response.file_name;
          this.msg = response.message;
          this.showMessage = true;
          this.MessageToShow = JSON.stringify(response);
        }
        else if(response.message == 'select bjl n2p'){
            this.showADRCard = false;
            this.select_bjl = true;    
            this.inputData =  response;  
            //this.tableChildComponent.initializeFunction(this.inputData);
        } 
        else if (response.message == 'select upstream equipment n2p') {
            this.show_smp_table = false;
            this.upstream_screen = true;
            this.select_smp_screen = false;
            this.inputData = response;
            this.tableData = response;
            //this.tableChildComponent.initializeFunction(this.inputData);
        }
        else if (response.message == 'n2p process completed') {
              this.map_div = false;
              this.select_smp_screen = false;
              this.upstream_screen = false;
              this.select_bjl = false;
              this.final_screen = true;
              this.tableData = response;
              this.inputData = response;
        }
        else {
          this.url = response.url;
          this.filename = response.file_name;
          this.msg = response.message;
          this.showMessage = true;
          this.MessageToShow = JSON.stringify(response);
        }
        this.isLoading = false;
        this.spinner.hide();
        // window.alert(response.messgae);
      },
      error: (error) => {
        this.isLoading = false;
        this.spinner.hide();
        this.toastr.error(
          `The API returned Unsuccessfull response : ${error}`,
          'Error Message'
        );
        //window.alert(`The API returned Unsuccessfull response : ${error}`);
      },
    });
  }
  
checkDistance(){

    this.isLoading = true;
    this.show_distance = false;
    this.show_status = false;
    this.update_pit = false;
    this.spinner.show();
    this.inputData['selected_bjl_val'] = this.inputData.selected_bjl.bjl_id;
    this.inputData['selected_pit_val'] = this.pit_value;
    this.apiService.pitBjlDistance(this.inputData).subscribe({
        next: (response) => {
          if (response.message == 'select smp structure') {
              
              this.upstream_screen = false;
              this.inputData = response;
              this.tableData = response;
              this.select_smp_screen = true;
              this.show_smp_table = true;
              
              this.show_status = true;
              this.pit_validation = this.inputData.pit_validation;
              if(this.pit_validation.pit_location == undefined || this.pit_validation.pit_location == null ) {
                  this.show_distance = true;
                  //this.tableChildComponent.initializeFunction(this.inputData);
                  this.mapChildComponent.receiveTableEvent(this.inputData);
              }
              //this.pit_validation.pit_status = false;
              if(this.pit_validation.pit_status == false){
                this.update_pit = true;
              }
              this.mapChildComponent.receiveTableEvent(this.inputData);
          }
          
          else if (response.message == 'select bjl n2p') {
              this.show_smp_table = false;
              this.upstream_screen = false;
              this.select_bjl = true;
              this.inputData = response;
              this.tableData = response;
              this.show_distance = false;
              this.tableChildComponent.initializeFunction(this.inputData);
            }
          else if (response.message == 'select upstream equipment n2p') {
              this.show_smp_table = false;
              this.upstream_screen = true;
              this.select_smp_screen = false;
              this.inputData = response;
              this.tableData = response;
              //this.tableChildComponent.initializeFunction(this.inputData);
            }
            else if(response.message == "Pit Fitness Failed"){
            this.update_pit = true;
            this.show_status = true;
            this.inputData = response;
            this.pit_validation = this.inputData.pit_validation;
            if(this.pit_validation.pit_distance == 'no path'){
                this.trench_creation = true;
                this.update_pit = false;
              }
            this.toastr.error(response.message, 'Error Message');
          }
          else {              
              if ('file_name' in response) {
                
                this.showMessage = true;
                this.MessageToShow = response;
              } else {
                this.toastr.error(response.message, 'Error Message');
                console.log('error');
              }
            } 

          this.isLoading = false;
          this.spinner.hide();
        },
        error: (error) => {
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(
            `The API returned Unsuccessfull response : ${error}`,
            'Error Message'
          );
        },
      });
  }
  inputOnChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.pit_value = input.value
    console.log('Value:', input.value);
  }

  fjlinputOnChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.fjl_id = input.value
    console.log('Value:', input.value);
  }
  

  skipLocations(){
    this.isLoading = true;
    this.spinner.show();
    //this.inputData['selected_bjl_val'] = this.inputData.selected_bjl.bjl_id;
    //this.inputData['selected_pit_val'] = this.pit_value;
    this.apiService.skipUnwatedLoc(this.inputData).subscribe({
        next: (response) => {
          if (response.message == 'n2p process completed') {
              this.map_div = false;
              this.upstream_screen = false;
              this.inputData = response;
              this.tableData = response;
              this.select_smp_screen = false;
              this.show_smp_table = false;
              this.show_distance = false;
              this.show_status = false;
              this.select_bjl = false;
              this.pit_validation = this.inputData.pit_validation;
              this.final_screen = true;
              //this.tableChildComponent.initializeFunction(this.inputData);
          } else {
            //this.showTable = false;
              this.toastr.error(
              `The API returned Unsuccessfull response`,
              'Error Message'
            );
          }

          this.isLoading = false;
          this.spinner.hide();
        },
        error: (error) => {
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(
            `The API returned Unsuccessfull response : ${error}`,
            'Error Message'
          );
        },
      });
  }

  pitSizeOnChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.pit_size_value = input.value
    console.log('Value:', input.value);
  }

  pitSizeChange(){
    this.isLoading = true;
    this.spinner.show();
    this.inputData['updated_pit_size'] = this.pit_size_value;
    this.inputData['selected_pit_val'] = this.pit_value;
    this.apiService.pitSizeUpdate(this.inputData).subscribe({
        next: (response) => {
          if (response.message == 'pit size updated successfully') {              
              this.update_pit = false;
              this.inputData = response;
              this.tableData = response;
              this.mapChildComponent.receiveTableEventPit(this.inputData);
              this.inputData['selected_pit_val'] = '';
              this.inputData['updated_pit_size'] = '';
              this.toastr.success(
              response.message,
              'success Message'
            );
              
          } else if(response.message == "Pit Fitness Failed"){
            this.update_pit = true;
          }else {
            //this.showTable = false;
              this.toastr.error(
              `The API returned Unsuccessfull response`,
              'Error Message'
            );
          }

          this.isLoading = false;
          this.spinner.hide();
        },
        error: (error) => {
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(
            `The API returned Unsuccessfull response : ${error}`,
            'Error Message'
          );
        },
      });
  }

onSubmit(){
    this.isLoading = true;
    this.spinner.show();
    this.inputData['a_pit'] = this.a_pit;
    this.inputData['z_pit'] = this.z_pit;
    this.inputData['no_of_pits'] = this.no_of_pits;
    this.apiService.createTrenchN2P(this.inputData).subscribe({
        next: (response) => {
          if (response.message == 'New Pit and Trenches Created') {              
              this.update_pit = true;
              this.trench_creation = false;
              this.inputData = response;
              this.tableData = response;
              this.mapChildComponent.receiveTableEventPit(this.inputData);
              this.toastr.success(
                response.message,
                'success Message'
              );
              
          } else if(response.message == "Process Failed"){
            this.update_pit = false;
            this.trench_creation = true;
            this.toastr.success(
                response.message,
                'Error Message'
              );
          }else {
            //this.showTable = false;
              this.toastr.error(
              `The API returned Unsuccessfull response`,
              'Error Message'
            );
          }

          this.isLoading = false;
          this.spinner.hide();
        },
        error: (error) => {
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(
            `The API returned Unsuccessfull response : ${error}`,
            'Error Message'
          );
        },
      });
  }
 
  updateVal(event: Event,field_type:string){
    const input = event.target as HTMLInputElement;
    if(field_type == 'a_pit'){
        this.a_pit = input.value
    }
    else if(field_type == 'z_pit'){
      this.z_pit = input.value
    }
    else if(field_type == 'no_of_pits'){
      this.no_of_pits = input.value
    }
  }

 
}
